// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import React from 'react';

import {ALLOWED_TIMEZONE} from 'graphql-client/__generated/GeneratedEnumMaps';
import {AllowedTimezone} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  institutionInfoLinksByUrl,
  LicensedInstitutionInfoLink,
} from 'help/institutions/InstitutionModalConstants';
import {Institution} from 'institutions/InstitutionConstants';
import InstitutionSelector from 'institutions/InstitutionSelector';
import notifications from 'notifications';
import NotificationPreferencesSection from 'notifications/preferences/NotificationPreferencesSection';
import * as popup from 'Popup';
import APIKeyRowTemplate, {APIKeyRowProps} from 'profile/APIKeyRowTemplate';
import ProfileAPISection from 'profile/ProfileAPISection';
import ProfileLocalePicker from 'profile/ProfileLocalePicker';
import ProfilePipeBioIntegrationSettings from 'profile/ProfilePipeBioIntegrationSettings';
import SuccessfulAPIKeyCreationModal from 'profile/SuccessfulAPIKeyCreationModal';
import SuccessfulPipeBioTokenCreationModal from 'profile/SuccessfulPipeBioTokenCreationModal';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import * as ModalContainer from 'ui-library/ModalContainer';
import * as net from 'util/Net';
import WarehouseLogins from 'warehouse/WarehouseLogins';

class APIKey extends Backbone.Model {
  // @ts-expect-error - Backbone types declare `url` as a property, but works as a method too
  url(): string {
    const base = '/1/api/users/me/keys/';
    if (this.id) {
      return `${base}${this.id}`;
    } else {
      return base;
    }
  }
}

class APIKeyRow extends Backbone.View<APIKey> {
  template!: (props: APIKeyRowProps) => string;

  static initClass(): void {
    this.prototype.template = APIKeyRowTemplate;
    this.prototype.tagName = 'tr';

    this.prototype.events = {
      // @ts-expect-error: This is a legit JQueryEventObject but it is not being recognized by TS
      'click .delete': 'revokeAPIKey',
    };
  }

  revokeAPIKey(): void {
    this.model
      .destroy({wait: true})
      .fail(notifications.notifyError)
      .done(() => {
        notifications.success('API Key revoked successfully.');
      });
  }

  render(): this {
    const model = {
      apiKey: this.model.toJSON(),
    };
    this.$el.html(this.template(model));
    return this;
  }
}

APIKeyRow.initClass();

class SelectedInstitution extends Backbone.Model {
  institution!: Institution | null;

  initialize({institution}: {institution: Institution | null}): void {
    this.institution = institution;
  }
}

class ProfileSettingsView extends Backbone.View<Backbone.Model> {
  APIKeys!: Backbone.Collection<APIKey>;
  pipebioTokenModel!: Backbone.Model;
  selectedInstitution!: SelectedInstitution;

  static initClass(): void {
    this.prototype.el = '#settings';
    this.prototype.events = {
      // @ts-expect-error: This is a legit JQueryEventObject but it is not being recognized by TS
      'submit .add-member-form': 'handleAddMember',
      'click .js-generate-api-key': 'generateAPIKey',
      'click .js-generate-pipebio-token': 'generatePipeBioToken',
    };
  }

  initialize(): void {
    this.selectedInstitution = new SelectedInstitution({
      institution: window.bootstrap!.entity!.institution,
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.selectedInstitution, 'change', this.mountInstitutionInfoLink);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.selectedInstitution, 'change', this.mountInstitutionSelector);

    if (window.bootstrap != null ? window.bootstrap.api_enabled : undefined) {
      this.APIKeys = new Backbone.Collection(window.bootstrap!.api_keys, {model: APIKey});
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.listenTo(this.APIKeys, 'add remove reset', this.renderAPIKeys);
    }
    if (window.bootstrap != null) {
      this.pipebioTokenModel = new Backbone.Model({
        pipebioTokenHint: window.bootstrap.pipebio_token_hint,
        pipebioTokenExpiresAt: window.bootstrap.pipebio_token_expires_at,
      });
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.listenTo(this.pipebioTokenModel, 'change reset', this.mountPipeBioSection);
    }
  }

  generateAPIKey(): void {
    const action = (): void => {
      new APIKey()
        .save({wait: true})
        .done((res: {id: number; key: string; created_at: string; key_hint: string}) => {
          // @ts-expect-error We are misusing Backbone here; we should be passing an array
          this.APIKeys.reset(res);
          ModalContainer.open(
            SuccessfulAPIKeyCreationModal,
            <SuccessfulAPIKeyCreationModal
              apiKey={res.key}
              onRequestClose={() => {
                ModalContainer.close(SuccessfulAPIKeyCreationModal);
              }}
            />
          );
        });
    };

    if (!this.APIKeys.isEmpty()) {
      const msg = 'Generating a new API key will delete your current one. Are you sure?';
      new popup.Confirm({title: 'Confirm API Key Regeneration', msg})
        .choice('Confirm', 'btn-af-primary', action)
        .show();
    } else {
      action();
    }
  }

  renderAPIKeys(): void {
    let buttonText;
    const els = Array.from(this.APIKeys.models).map((key) => new APIKeyRow({model: key}).render().el);
    // @ts-expect-error You can put whatever you want in .html in JQuery, even if you shouldn't
    this.$el.find('.api-keys').html(els);
    this.$('.api-key-table').toggleClass('hidden', this.APIKeys.isEmpty());
    if (this.APIKeys.isEmpty()) {
      buttonText = 'Generate New API Key';
    } else {
      buttonText = 'Regenerate API Key';
    }

    this.$('.js-generate-api-key').text(buttonText);
  }

  generatePipeBioToken(): void {
    net
      .postPromise({url: `/1/api/users/me/pipebio-token/`})
      .then((res) => {
        this.pipebioTokenModel.set({
          pipebioTokenHint: res.token_hint,
          pipebioTokenExpiresAt: res.expires_at,
        });
        const token = res.token;
        ModalContainer.open(
          SuccessfulPipeBioTokenCreationModal,
          <SuccessfulPipeBioTokenCreationModal
            token={token}
            onRequestClose={() => {
              ModalContainer.close(SuccessfulPipeBioTokenCreationModal);
            }}
          />
        );
      })
      .catch((error) => {
        // @ts-expect-error You need to put a server response here, not just a string
        notifications.notifyError('Error generating PipeBio token');
      });
  }

  mountInstitutionSelector(): void {
    const $mount = this.$('.js-institution.react-mount');

    if ($mount.length) {
      const model = this.selectedInstitution;
      renderToDOM(
        <InstitutionSelector
          placeholder="No institution selected"
          allowLeaving={true}
          value={model.get('institution')}
          onChange={(institution) => model.set({institution})}
          className="u-small-spacing-bottom"
          disabled={model.get('institution') && model.get('institution').licensed}
        />,
        $mount[0]
      );
    }
  }

  mountLanguageTagPicker(): void {
    const $mount = this.$('.js-language-tag.react-mount');
    const name = 'language_tag';
    renderToDOM(
      <ProfileLocalePicker
        name={name}
        // This input will exist at first, and then get clobbered by `ProfileLocalePicker`, which creates and
        // updates its own hidden input for the form
        initialValue={$mount.find(`input[name=${name}]`).val()}
      />,
      $mount[0]
    );
  }

  mountWarehouseLogins(): void {
    const $mount = this.$('.js-warehouse.react-mount');
    if (!$mount.length) {
      return;
    }
    renderToDOM(<WarehouseLogins />, $mount[0]);
  }

  mountNotificationsOptOutSetting(): void {
    const $mount = this.$('.js-notifications-opt-out-setting.react-mount');
    if (!$mount.length) {
      return;
    }
    const deliveryTimezone = Object.keys(ALLOWED_TIMEZONE).find(
      (key: AllowedTimezone) => ALLOWED_TIMEZONE[key] === window.bootstrap!.notificationDeliveryTimezone
    ) as AllowedTimezone;
    renderToDOM(
      <NotificationPreferencesSection
        notificationOptOutPreferences={window.bootstrap!.notificationOptOutPreferences}
        deliveryTimezonePreference={deliveryTimezone}
      />,
      $mount[0]
    );
  }

  mountAPISection(): void {
    const $mount = this.$('.js-api.react-mount');
    if (!$mount.length) {
      return;
    }
    renderToDOM(<ProfileAPISection />, $mount[0]);
  }

  mountPipeBioSection(): void {
    const $mount = this.$('.js-pipebio.react-mount');
    if (!$mount.length) {
      return;
    }
    renderToDOM(
      <ProfilePipeBioIntegrationSettings
        pipebioTokenHint={this.pipebioTokenModel.get('pipebioTokenHint')}
        pipebioTokenExpiresAt={this.pipebioTokenModel.get('pipebioTokenExpiresAt')}
      />,
      $mount[0]
    );
  }

  mountInstitutionInfoLink(): void {
    const $mount = this.$('.js-institution-info-link');
    if (!$mount.length) {
      return;
    }
    const institution: Institution | null = this.selectedInstitution.get('institution');
    const urlIdentifier = institution && institution.urlIdentifier;

    const urlInfoLink: (() => JSX.Element) | undefined =
      // @ts-expect-error urlIdentifier is probably not `broad`, the only key in `institutionInfoLinksByUrl`.
      // So we can expect to get back `undefined` here
      urlIdentifier && institutionInfoLinksByUrl[urlIdentifier];

    if (urlInfoLink) {
      renderToDOM(React.createElement(urlInfoLink), $mount[0]);
    } else if (institution && institution.licensed) {
      renderToDOM(<LicensedInstitutionInfoLink institution={institution} />, $mount[0]);
    } else {
      this.unmountInstitutionInfoLink($mount[0]);
    }
  }

  unmountInstitutionInfoLink($el: Element): void {
    renderToDOM(<div />, $el);
  }

  render(): this {
    this.mountInstitutionSelector();
    this.mountInstitutionInfoLink();
    this.mountLanguageTagPicker();
    this.mountAPISection();
    this.mountPipeBioSection();
    if (this.APIKeys != null) {
      this.renderAPIKeys();
    }

    this.mountWarehouseLogins();
    this.mountNotificationsOptOutSetting();

    return this;
  }
}

ProfileSettingsView.initClass();

export default ProfileSettingsView;
